export default __webpack_public_path__ + "static/media/fontawesome-webfont.0317d582.woff2";